module.exports = __webpack_public_path__ + "static/media/za-vaspitacice-i-uciteljice.c5d50b65.png";